/**
 * Relative-time formatter voor cn-reviews-cards.
 *
 * Vervangt de oude brittle Liquid `.replace('minutes ago', ...)` chain
 * door native Intl.RelativeTimeFormat. Locale wordt afgeleid van
 * <html lang="..."> (Shopify zet die per request.locale).
 *
 * Liquid rendert: <span data-cn-relative-time="{{ unix_timestamp }}">
 *                   {{ raw_fallback_text }}
 *                 </span>
 *
 * Deze script scant DOM op DOMContentLoaded en vervangt textContent
 * met de gelocaliseerde "X minutes/hours/days ago". Bij parse-fail OF
 * geen Intl.RelativeTimeFormat ondersteuning blijft de Liquid-fallback
 * staan — graceful degrade.
 */
(function () {
  'use strict';

  if (typeof Intl === 'undefined' || typeof Intl.RelativeTimeFormat !== 'function') {
    return;
  }

  var locale = (document.documentElement.lang || 'nl').replace('_', '-');
  var rtf;
  try {
    rtf = new Intl.RelativeTimeFormat(locale, { numeric: 'auto' });
  } catch (e) {
    rtf = new Intl.RelativeTimeFormat('nl', { numeric: 'auto' });
  }

  /**
   * Pak de grootste tijdseenheid die ≥1 is. -value want past → negatief.
   */
  function formatSince(unixSeconds) {
    var nowSec = Date.now() / 1000;
    var diffSec = unixSeconds - nowSec; // negatief voor verleden
    var absSec = Math.abs(diffSec);
    var sign = diffSec < 0 ? -1 : 1;

    if (absSec < 60) return rtf.format(Math.round(diffSec), 'second');
    if (absSec < 3600) return rtf.format(Math.round(diffSec / 60), 'minute');
    if (absSec < 86400) return rtf.format(Math.round(diffSec / 3600), 'hour');
    if (absSec < 86400 * 7) return rtf.format(Math.round(diffSec / 86400), 'day');
    if (absSec < 86400 * 30) return rtf.format(Math.round(diffSec / (86400 * 7)), 'week');
    if (absSec < 86400 * 365) return rtf.format(Math.round(diffSec / (86400 * 30)), 'month');
    return rtf.format(Math.round(diffSec / (86400 * 365)), 'year');
  }

  function applyAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var nodes = scope.querySelectorAll('[data-cn-relative-time]');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (el.dataset.cnRtfApplied === '1') continue;
      var ts = parseInt(el.dataset.cnRelativeTime, 10);
      if (!ts || isNaN(ts)) continue;
      try {
        el.textContent = formatSince(ts);
        el.dataset.cnRtfApplied = '1';
      } catch (e) {
        // Laat Liquid fallback staan.
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { applyAll(document); });
  } else {
    applyAll(document);
  }

  // Re-scan bij dynamische content (quickview, ajax-loaded reviews etc.)
  if (typeof MutationObserver === 'function') {
    var mo = new MutationObserver(function () { applyAll(document); });
    mo.observe(document.body, { childList: true, subtree: true });
  }
})();
